import React, { useState } from 'react';

export enum FieldNames {
	PREVIOUS_PREGNANCIES = 'previousPregnancies',
	MOTHERS_HEALTH = 'mothersHealth',
	LAB_RESULTS = 'labResults',
	FINAL_STEP = 'finalStep',
	CURRENT_PREGNANCY = 'currentPregnancy',
}

export type ContextDataProps = {
	[x in FieldNames]?: string;
};
export interface HealthPlanContextProps {
	setData: (data: ContextDataProps) => void;
	data: ContextDataProps;
}

export const HealthPlanContext = React.createContext(
	{} as HealthPlanContextProps,
);

interface Props {
	children: React.ReactElement;
}

export const HealthBabyPlanDataProvider = ({ children }: Props) => {
	const [data, setData] = useState<ContextDataProps>({});

	const handleSaveData = (newFields: ContextDataProps) => {
		setData(prevData => ({
			...prevData,
			...newFields,
		}));
	};

	return (
		<HealthPlanContext.Provider value={{ data, setData: handleSaveData }}>
			{children}
		</HealthPlanContext.Provider>
	);
};
